import { useEffect, useRef, useState } from "react"
import { _HelpDesk, _single, _Test } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const TURNO001 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({});
    const { _procedure, _pocessData, _exportMap, _pushInfo, _pushProps } = configProcedure;    
    const [obs, setObs] = useState<string>('');
        

    useEffect(() => {
        if (_pocessData?.Props) {
            setProps(_pocessData?.Props)
        }

    }, [configProcedure?._pocessData])
   
    const enviardata =()=>{

                
        _pushInfo(
            _single.jsonToBootstrapTable({
            "Observacion":obs
        })
        );
       
        _exportMap({
            Encuesta:JSON.stringify({
                Observacion:obs
            })
        })
    }

    return (
        <div className="row">
            <div className="col-md-12">
               <label>Observaciones</label>
               <textarea name="obs" className="form-control" value={obs} onChange={(e)=>{setObs(e.target.value)}} ></textarea>
            </div>
            <div className="col-md-12">
                <BasicButton icon="" eventClick={enviardata}>Guardar</BasicButton>
                {/* <PrintJson json={response.current} /> */}
            </div>
        </div>
    )
}